import React, { Component } from 'react';

import { Container, Row, Col } from 'react-bootstrap';

import * as fn from '../library/function';
import * as constants from '../config/constants/AppConstants';
import * as helper from '../library/helper';
import * as util from '../library/utilitys';

import CommonPageHeader from './components/CommonPageHeader';
import CommonToolbar from './components/CommonToolbar';
import CommonToast from './components/CommonToast';
import CommonConfirmModal from './components/CommonConfirmModal';
import CommonPreviewFileModal from './components/CommonPreviewFileModal';

import CommonTokenExpired from './components/CommonTokenExpired';

import Cookies from "js-cookie";

/** withRouter */
import withRouter from "./components/withRouter"

/** start individual component */
import InputEB02DataCourse from './inputs/InputEB02DataCourse';
import SearchEB02DataCourse from './searchs/SearchEB02DataCourse';
import DataTableEB02DataCourse from './dataTables/DataTableEB02DataCourse';
/** end individual component */

import * as Actions from './actions/ActionCenter';

import { GlobalStates } from './states/GlobalStates';

/** individual page state */
import { PageDataState } from './states/EB02DataCourseEB02State';

/** requester handle */
import requester from "../library/Requester"; 

/** define end point */
const TABLE = `course_eb_02`;
const URL = `api/master/${TABLE}`;

const rawProfile = Cookies.get("userProfile");
const userProfile = rawProfile ? JSON.parse(rawProfile) : {};

class EB02DataCourse extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);
    }

    initialize = async () => {
        await this.loadMasterbase();
        await this.loadDataTable();
        await this.setDefaultSearchs();
    }

    loadMasterbase = async () => {
        let sets = [
            {key: "course_eb_01", filter: [{ field: 'status', value: '0' }, { field: 'status', value: '1' } ]},
            {key: "academy", filter: [{ field: "status", value: "0" }]},
            {key: "users", filter: [
                { field: 'types', value: '2' }, 
                { field: 'status', value: '0' }]
            },
        ]; 
        Actions.loadMasterbase(this.updateState, sets);
    }

    loadDataTable = async (search = false) => {
        const { Searchs, DataTable } = this.state;

        const cookieSearchs = {};
        
        if (userProfile.academy_id && !["0","1"].includes(userProfile.types))  {
            cookieSearchs.academy_id = { id: "academy_id", value: userProfile.academy_id };
        }
        
        const mergedSearchs = {
            ...Searchs,
            ...cookieSearchs,
            page: {
                id: "page",
                value: search ? 1 : DataTable.pagination.currentPage,
            },
        };

        await Actions.loadDataTable(
            this.updateState,
            `${URL}/pagination`,
            fn.getInputSearch(mergedSearchs)
        );
    }

    setDefaultSearchs = async () => {
        let defaultsSearchs = {};
         switch (userProfile.types) {
            case "2": // academy
                defaultsSearchs.academy_id = userProfile.academy_id;
            break;
            default:
                //(admin) ไม่เซ็ตค่า
            break;
        }
        await Actions.setDefaultSearchs(this.updateState,defaultsSearchs); 
        
    }
    
    navigate = (e = {}, obj = {}) => {

        const { Searchs, DataTable, Operation } = this.state; 
                
        const key = 'course_eb_02';

        Actions.navigate(this.props.navigate, "/apps/" + e.target.value , {
            direction: 'drilldown',
            key: key,
            restore: {},
            [key]: {
                parameters: {...obj},
                searchs: Searchs,
                operation: Operation,
                currentPage: DataTable.pagination.currentPage,
            },
        });
    };

    updateSomething = async (obj, element, pk) => {
        await Actions.updateSomething(this.updateState, `${URL}/update-something`, element, pk, obj, this.loadDataTable);
    }

    fetchForEdit = async (obj, approved = false) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'OffCanvas', mode: 'update', bool: true},
            this.state.Inputs
        );

        this.resetApproved(approved);
    }

    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, this.loadDataTable);
        await this.resetApproved(false);
    }

    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state; 
        await Actions.submitData(
            this.updateState,
            `${URL}`,
            Action.Mode, 
            fn.getInputForm({...Inputs}),
            this.loadDataTable,
            null,
            this.state.Inputs
        );
        await this.resetApproved(false);
    }

    parametersControl = async (state) => {
        if (state) {
            const { direction, key, restore, ...object } = state;
            await Actions.parametersPrompt(this.updateState, key, object[key], restore);
            this.setDefaultInputs();
        }
    
        const shouldInitialize = !!state; 
        if (shouldInitialize) {
            await this.initialize();
        }
    };
    
    setDefaultInputs = async () => {
        await Actions.setDefaultInputs(this.updateState, 'course_eb_01', async () => {
            const { Action, Inputs } = this.state;
        
            this.setState({Inputs: Inputs});      
        });
        
        await Actions.setProfileInputs(this.updateState, {
            academy_id: "academy_id",
        });
    }

    resetApproved = async (approved) => {
        this.updateState(
            (prevState) => ({
                ...prevState,
                Approved: approved
            })
        );        
    }

    componentDidMount = async () => {
        const state = this.props.location.state || {} ;
        
        if (util.isObject(state)){
            this.parametersControl(state); 
        } else {
            await this.initialize(); 
        }
    }

    componentDidUpdate = async () => {}   

    render = () => {

        let { Action, Searchs, DataTable, Inputs, InputGroup, Masterbase, Deletes, Operation, Approved, Token } = this.state;

        let AppProps = constants.AppProps[helper.getCurrentRoute()];

        return (
            <>
                <Container>

                    <CommonPageHeader object={AppProps}/>

                    <CommonTokenExpired Token={Token} />

                    <CommonPreviewFileModal
                        Action={Action}
                        onClose={() => Actions.handleClosePreviewFile(this.updateState)}
                    />                    

                    <CommonToolbar 
                        config={AppProps.toolbar}
                        
                        Operation={Operation}
                        Deletes={Deletes}

                        onToggleSearch={(e) => Actions.handleToggleItem(this.updateState, 'Operation', 'Search')}

                        onRefreshDataTable={async (e) => await this.loadDataTable()}
                        
                        onCreateItem={(e) => Actions.handleOpenInputForm(this.updateState, 'OffCanvas', 'new', true, this.setDefaultInputs)}
                        onModalAction={(e) => Actions.handleControlModal(this.updateState, e)}
                    />

                    <CommonToast 
                        toast={Action.Toast} 

                        onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                    />

                    <CommonConfirmModal 
                        Action={Action}
                        Deletes={Deletes}

                        onCallback={async (e) => { 
                            let result = await Actions.handleControlModal(this.updateState, e);
                            if(result.action){
                                if (result.section === 'Delete'){ await this.deleteData(); }
                            }
                         }}
                    />

                    <SearchEB02DataCourse 
                        Action={Action}
                        Searchs={Searchs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        UserCookie={userProfile}

                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}

                        onSearch={async (e) => await this.loadDataTable(true)}
                    />

                    <DataTableEB02DataCourse 
                        Action={Action}
                        DataTable={DataTable}
                        Inputs={Inputs}
                        Deletes={Deletes}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        UserCookie={userProfile}

                        onSetEdit={async (e, obj, approved = false) => { await this.fetchForEdit(obj, approved); }}
                        onNavigate={(e, obj) => this.navigate(e, obj)}
                        onDropDownChange={async(e, element, pk) => { await this.updateSomething(e, element, pk)} }

                        onCheckDelete={(e) =>  Actions.handleDataTableToggleDelete(this.updateState, e) }
                        onCheckDeleteAll={(e, deletes) => Actions.handleDataTableToggleDeleteAll(this.updateState, e, deletes)}
                        onPaginationChange={(paging) => Actions.handleDataTablePaginationChange(this.updateState, paging, this.loadDataTable)}
                    />

                    <InputEB02DataCourse 
                        URL={URL}
                        
                        App={AppProps}

                        Action={Action}
                        Inputs={Inputs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        Approved={Approved}
                        UserCookie={userProfile}

                        onUpdateState={(key, value) => Actions.updateState(this.updateState, key, value)}
                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                        onCloseAlert={(e) => { Actions.handleCloseAlert(this.updateState, 'Alert', e); }}

                        onPreviewFile={(e) => Actions.handlePreviewFile(this.updateState, e)}
                        onDeleteFile={(field, pk) => Actions.deleteFile(this.updateState, URL, field, pk)}                        

                        onSubmit={async (e) => { await this.submitData()}}
                        
                        onDiscardSubmit={(e) => { Actions.handleDiscardInputs(this.updateState, 'Inputs'); }}
                        onClose={(e) => {
                                Actions.handleDiscardInputs(this.updateState, 'Inputs');
                                Actions.handleCloseInputForm(this.updateState, 'OffCanvas')
                            }
                        }
                    />
                </Container>
            </>
        )
    }
}

export default withRouter(EB02DataCourse);